import type { User } from 'features/auth';

export const canViewPasskeys = ({ viewer }: { viewer: User }) =>
  Boolean(viewer.nodeUserData.roles.admin) || Boolean(viewer.nodeUserData.roles.personnel);
